import { createInputs } from '../../utils';

export default createInputs([
  { name: 'position', type: 'number', required: false },
  { name: 'title', type: 'string', required: true },
  { name: 'subtitle', type: 'string', required: true },
  { name: 'image', type: 'file', required: true },
  { name: 'alt', type: 'string', required: false },
]);
